import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Editor from './components/Editor';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import Pricing from './pages/Pricing';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import CGU from './pages/CGU';
import Privacy from './pages/Privacy';
import CookieConsent from './components/CookieConsent';
import MobileWarning from './components/MobileWarning';
import CompositeCard from './pages/CompositeCard';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <CookieConsent />
      <MobileWarning />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/editeur" element={<Editor />} />
        <Route path="/comment-ca-marche" element={<HowItWorks />} />
        <Route path="/tarifs" element={<Pricing />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/confidentialite" element={<Privacy />} />
        <Route path="/composite-card" element={<CompositeCard />} />
        <Route path="/admin-compify-42" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;